import React, { memo, useCallback } from 'react';
import { TouchableOpacity, type TouchableOpacityProps } from 'react-native';

// ─────────────────────────────────────────────────────────────────────────────

export const CustomizationActiveIngredientPressable = memo((props: Props) => {
  const { groupId, groupDisplayName, onPress, ...pressableProps } = props;

  // ─── Helpers ─────────────────────────────────────────────────────────

  const handlePress = useCallback(() => {
    onPress(groupId, groupDisplayName);
  }, [groupId, groupDisplayName, onPress]);

  // ─────────────────────────────────────────────────────────────────────

  return (
    <TouchableOpacity
      activeOpacity={0.7}
      onPress={handlePress}
      {...pressableProps}
    />
  );
});

// ─── Types ───────────────────────────────────────────────────────────────────

type Props = {
  groupId: string;
  groupDisplayName: string;
  onPress: (groupId: string, groupDisplayName: string) => void;
} & Omit<TouchableOpacityProps, 'onPress'>;
